import { signalStore, type, withState } from '@ngrx/signals';
import { eventGroup, on, withReducer } from '@ngrx/signals/events';

export const HeaderAppearanceEvents = eventGroup({
  source: 'Header Appearance',
  events: {
    requestHero: type<void>(),
    requestUnhero: type<void>(),
  },
});

export const HeaderStateStore = signalStore(
  { providedIn: 'root' },
  withState({ hero: false }),
  withReducer(
    on(HeaderAppearanceEvents.requestHero, () => ({ hero: true })),
    on(HeaderAppearanceEvents.requestUnhero, () => ({ hero: false })),
  ),
);
